// extracted by mini-css-extract-plugin
export var activeDot = "_3c-c";
export var buttonContainer = "_3c-9";
export var channelButton = "_3c-a";
export var clickable = "_3c-d";
export var content = "_3c-0";
export var contentFull = "_3c-2";
export var contentThird = "_3c-1";
export var contentWrapper = "_3c-7";
export var description = "_3c-5";
export var heightShort = "_3c-f";
export var image = "_3c-3";
export var imageContainer = "_3c-4";
export var selectButton = "_3c-e";
export var spinnerContainer = "_3c-b";
export var titleContent = "_3c-8";
export var titleWrapper = "_3c-6";